export const AUDIT_LABELS = {
  PAGE_TITLE: "Trilha de Auditoria",
  PAGE_DESCRIPTION:
    "A consulta devolve apenas as entidades que o seu perfil enxerga.",
  FILTER_ACTOR: "Usuário",
  FILTER_ACTOR_PLACEHOLDER: "Trecho do e-mail",
  FILTER_ACTION: "Ação",
  FILTER_ENTITY: "Entidade",
  FILTER_ENTITY_ID: "Nº do registro",
  FILTER_PERIOD: "Período",
  FILTER_PERIOD_PLACEHOLDER: "Selecione um período",
  CLEAR_FILTERS: "Limpar filtros",
  COLUMN_WHEN: "Data / Hora",
  COLUMN_WHO: "Usuário",
  COLUMN_WHAT: "O que aconteceu",
  COLUMN_ORIGIN: "Origem",
  EMPTY: "Nenhum registro para os filtros selecionados",
  EMPTY_SCOPE:
    "Seu perfil não tem leitura em nenhuma entidade auditada — por isso a trilha aparece vazia.",
  AUTOMATIC_ACTOR: "Sistema (rotina automática)",
  NO_IP: "—",
  TOTAL: (total: number): string => `${total} registro(s)`,
  ROWS_PER_PAGE: "Linhas por página",
  PREVIOUS_PAGE: "Página anterior",
  NEXT_PAGE: "Próxima página",
  PAGE_OF: (current: number, last: number): string =>
    `Página ${current} de ${last}`,
} as const;

export const AUTOMATIC_ACTOR_EMAIL: string = "cron@sistema";
